module.exports = __webpack_public_path__ + "img/robotProjectWhite.ddbb9287.svg";